import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Box, styled } from '@mui/material';

const DialogBox = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const DialogboxWrapper = styled(Box)`
    
`

export interface DialogTitleProps {
    children?: React.ReactNode;
    onClose: () => void;
    open: boolean;
    type?: string
    className?: string
}

const DialogWrapper = (props: DialogTitleProps) => {
    const { children, open, type, onClose, className, ...other } = props;

    return (
        <DialogboxWrapper>
            <Box>
                <DialogBox open={open} onClose={onClose} className={`${type == "service" ? "dialogBoxWithOutBorder" : "dialogBox"} ${className}`}>

                    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
                        {children}
                        {onClose ? (
                            <IconButton
                                aria-label="close"
                                onClick={onClose}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        ) : null}
                    </DialogTitle>
                </DialogBox>
            </Box>
        </DialogboxWrapper>

    )
}

export default DialogWrapper 